module.exports = __webpack_public_path__ + "static/media/grayHandRaise.a3b87af2.svg";